import "./LocalSeoConsultantPreston.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Casestudies from "./sections/Casestudies";
import PrestonMarket from "./sections/PrestonMarket";
import AuditProcess from "./sections/AuditProcess";
import ConsultantVsAgency from "./sections/ConsultantVsAgency";
import Industry from "./sections/Industry";
import Localservices from "./sections/Localservices";
import Preston from "./sections/Preston";
import Localhero from "./sections/Localhero";
import PrestonFaq from "./sections/PrestonFaq";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantPrestonPage() {
  return <div>
      <Header />
      <Consultation />
      <Casestudies />
      <PrestonMarket />
      <AuditProcess />
      <ConsultantVsAgency />
      <Industry />
      <Localservices />
      <Preston />
      <Localhero />
      <PrestonFaq />
      <Footer />
    </div>;
}